import './Button.css'

export default function Button(props) {
    return (
        <button style = {{maxWidth: props.maxWidth || 'max-content', width: props.width || ""}} className = "Button" onClick = {props.onClick}>
            {props.text}
        </button>
    )
}